import React from 'react';
import MetaTags from '../components/MetaTags';
import { getHomepageSchema } from '../utils/schemaGenerator';
import './NewHomePage.css';

// Components
import NewHeroSection from '../components/new-home/NewHeroSection';
import TrustStrip from '../components/new-home/TrustStrip';
import LiveOpportunities from '../components/new-home/LiveOpportunities';
import TracksSection from '../components/new-home/TracksSection';
import HowItWorksSteps from '../components/new-home/HowItWorksSteps';
import AIStudioAndSuccess from '../components/new-home/AIStudioAndSuccess';
import StatsAndWorkshops from '../components/new-home/StatsAndWorkshops';
import BottomCTA from '../components/new-home/BottomCTA';

const NewHomePage = () => {
  const homepageSchema = getHomepageSchema();

  return (
    <div className="new-home-page">
      <MetaTags 
        title="Acting Auditions in India | Bollywood Casting Calls | BookMyAudition"
        description="Find the latest acting auditions in India and casting calls for films, web series, television, theatre and advertisements on BookMyAudition."
        keywords="acting auditions in India, auditions near me, latest auditions in India, upcoming auditions in India, casting calls India, acting casting calls, auditions for actors, BookMyAudition, Bollywood auditions, web series auditions, TV auditions, theatre auditions, ad film auditions"
        schema={homepageSchema}
      />
      
      <NewHeroSection />
      <TrustStrip />
      <LiveOpportunities />
      <TracksSection />
      <HowItWorksSteps />
      <AIStudioAndSuccess />
      <StatsAndWorkshops />
      <BottomCTA />
      
    </div>
  );
};

export default NewHomePage;
